var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFontSize = function SvgFontSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeLinecap: "round",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.5 2.196h17.405m-2.672 8.427 8.183.037m-3.974 11.583.045-11.51m-1.546 11.505 2.904.036m-12.813-.043 2.905.037M.5 2.196v2.39m9.03 17.645.038-19.926M17.94 2.196v2.39M15.163 10.744v1.604m8.253.156V10.66"
  })));
};
export default SvgFontSize;